import React from "react";

function FIlesvg() {
  return (
   <>
   <svg 
   xmlns="http://www.w3.org/2000/svg"  
   fill="none" 
   viewBox="0 0 24 24" 
   id="file-upload"
   style={{
    height:"3rem",
    width:"3rem",
    position:"relative",
    zIndex:"-1",
    marginTop:"-10px"
   }}>
  <path fill="url(#paint0_linear_201_3225)" d="M16 8C15.2044 8 14.4413 7.68393 13.8787 7.12132C13.3161 6.55871 13 5.79565 13 5V1H7C6.20435 1 5.44129 1.31607 4.87868 1.87868C4.31607 2.44129 4 3.20435 4 4V20C4 20.7956 4.31607 21.5587 4.87868 22.1213C5.44129 22.6839 6.20435 23 7 23H17C17.7956 23 18.5587 22.6839 19.1213 22.1213C19.6839 21.5587 20 20.7956 20 20V8H16ZM14.88 13.47C14.795 13.6297 14.6682 13.7633 14.5133 13.8566C14.3583 13.95 14.1809 13.9995 14 14H13V17C13 17.2652 12.8946 17.5196 12.7071 17.7071C12.5196 17.8946 12.2652 18 12 18C11.7348 18 11.4804 17.8946 11.2929 17.7071C11.1054 17.5196 11 17.2652 11 17V14H10C9.8191 13.9995 9.64171 13.95 9.48674 13.8566C9.33177 13.7633 9.20502 13.6297 9.12 13.47C9.03971 13.3136 9.00205 13.1389 9.01083 12.9633C9.01961 12.7877 9.07451 12.6176 9.17 12.47L11.17 9.47C11.2583 9.32873 11.3804 9.21174 11.5254 9.12966C11.6703 9.04759 11.8335 9.00301 12 9C12.1638 8.99975 12.3252 9.03975 12.4699 9.11647C12.6146 9.19319 12.7383 9.30429 12.83 9.44L14.83 12.44C14.9311 12.5909 14.9892 12.7666 14.998 12.9481C15.0068 13.1295 14.966 13.31 14.88 13.47Z"></path>
  <path fill="url(#paint1_linear_201_3225)" d="M20 6.82V8H16C15.2044 8 14.4413 7.68393 13.8787 7.12132C13.3161 6.55871 13 5.79565 13 5V1H14.2C14.4703 1.00151 14.7393 1.0385 15 1.11C15.5037 1.24969 15.9622 1.51857 16.33 1.89L19.13 4.71C19.4847 5.06997 19.7426 5.5137 19.88 6C19.9603 6.2659 20.0007 6.54224 20 6.82Z"></path>
  <path fill="url(#paint2_linear_201_3225)" d="M14.88 13.47C14.795 13.6297 14.6682 13.7633 14.5133 13.8566C14.3583 13.95 14.1809 13.9995 14 14H13V17C13 17.2652 12.8946 17.5196 12.7071 17.7071C12.5196 17.8946 12.2652 18 12 18C11.7348 18 11.4804 17.8946 11.2929 17.7071C11.1054 17.5196 11 17.2652 11 17V14H10C9.81909 13.9995 9.64171 13.95 9.48674 13.8566C9.33177 13.7633 9.20502 13.6297 9.12 13.47C9.03971 13.3136 9.00205 13.1389 9.01083 12.9633C9.01961 12.7877 9.07451 12.6176 9.17 12.47L11.17 9.47C11.2583 9.32873 11.3804 9.21174 11.5254 9.12967C11.6703 9.04759 11.8335 9.00302 12 9C12.1638 8.99975 12.3252 9.03975 12.4699 9.11647C12.6146 9.19319 12.7383 9.30429 12.83 9.44L14.83 12.44C14.9311 12.5909 14.9892 12.7666 14.998 12.9481C15.0068 13.1295 14.966 13.31 14.88 13.47Z"></path>
  <defs>
    <linearGradient id="paint0_linear_201_3225" x1="12" x2="12" y1="1" y2="23" gradientUnits="userSpaceOnUse">
      <stop stopColor="#FFA68D"></stop>
      <stop offset="1" stopColor="#FD3A84"></stop>
    </linearGradient>
    <linearGradient id="paint1_linear_201_3225" x1="16.5" x2="16.5" y1="1" y2="8" gradientUnits="userSpaceOnUse">
      <stop stopColor="#FFF2F4"></stop>
      <stop offset="1" stopColor="#FFE0E5"></stop>
    </linearGradient>
    <linearGradient id="paint2_linear_201_3225" x1="12.004" x2="12.004" y1="9" y2="18" gradientUnits="userSpaceOnUse">
      <stop stopColor="#FFF2F4"></stop>
      <stop offset="1" stopColor="#FFE0E5"></stop>
    </linearGradient>
  </defs>
</svg>
</>
  );
}

export default FIlesvg;
